<template>
  <v-card-text class="py-0" v-if="tariffStructure">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="2">
            <span></span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
// import { doGet, doPost } from "@/store/common/module/apis";
// import common from "@/store/common/module/common";

@Component
// ({
//   name: "FareDetail",
//   props: {
//     value: {
//       default: null,
//     },
//     fareTariffObj: {
//       default: () => {},
//     },
//     details: {
//       default: () => {},
//     },
//   },
// })
export default class FareDetail extends Vue {
  fare = null;

  async mounted() {
    // if (this.value) {
    //   this.tariffStructure = this.value;
    //   if (!this.tariffStructure.fuelFare) this.tariffStructure.fuelFare = {};
    // }
  }

  // @Watch("fareTariffObj")
  // async onValueChange(val) {
  //   common.setLoading(true);
  //   try {
  //     this.cargo.fare = await doPost(
  //       "/api/cargo/calc/fare",
  //       this.cargo
  //     );
  //     common.setLoading(false);
  //   } catch (e) {
  //     common.setError(e);
  //     common.setLoading(false);
  //   }
  // }
}
</script>
